import {Button, Col, Form, InputNumber, Row, Select} from 'antd';
import React, {useContext} from 'react';
import {sideMenuContext} from '../../../router/IndexRouter';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};
const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const formRef = React.createRef();

const DetailYearlyReport = () => {
	const {currentItem} = useContext(sideMenuContext);
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			initialValues={currentItem}
			style={{maxWidth: 1200, marginLeft: 40}}
			ref={formRef}
		>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="year" label="年报年度"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<InputNumber min={0} style={{width: 150}} disabled={true}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="publicShowState" label="公示状态" rules={[{required: true, message: '内容不能为空'}]}
						initialValue="已公示">
						<Select disabled={true}>
							<Select.Option value="已公示">已公示</Select.Option>
							<Select.Option value="未公示">未公示</Select.Option>
							<Select.Option value="未上报">未上报</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="checkContent" label="年报说明" rules={[{required: true, message: '内容不能为空'}]}>
						<div style={{marginTop: 4}} dangerouslySetInnerHTML={{__html: currentItem.checkContent}}/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<Button
					type="primary"
					htmlType="button"
					onClick={() => {
						window.history.back();
					}}
				>
					返回
				</Button>
			</Form.Item>

		</Form>
	);
};

export default DetailYearlyReport;
